module.exports = __webpack_public_path__ + "static/media/ic_shapes_circle_inverse.6f3846a1.svg";